import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function Confirmation() {
  const { orderNumber } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { money } = useApp();
  const [order, setOrder] = useState(null);

  useEffect(() => { api.get(`/orders/${orderNumber}`).then((r) => setOrder(r.data)).catch(() => {}); }, [orderNumber]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="w-16 h-16 rounded-full border-2 flex items-center justify-center mx-auto mb-8" style={{ borderColor: "var(--ev-accent)" }}>
        <Check size={28} strokeWidth={1.4} style={{ color: "var(--ev-accent)" }} />
      </div>
      <div className="eyebrow mb-3" style={{ color: "var(--ev-muted)" }}>Thank you</div>
      <h1 className="font-serif text-4xl mb-4">Your order is confirmed</h1>
      <p className="text-lg mb-2" style={{ color: "var(--ev-muted)" }}>Order <strong style={{ color: "var(--ev-text)" }}>{orderNumber}</strong></p>
      <p className="mb-10" style={{ color: "var(--ev-muted)" }}>A confirmation has been recorded for your purchase. Each item retains its storefront of origin.</p>

      {state?.unconfigured && (
        <div className="border p-5 mb-8 text-sm text-left" style={{ borderColor: "var(--ev-accent)", background: "var(--ev-bg)" }}>
          <strong>Payment configuration required.</strong> This order was created server-side with verified totals, but PayPal credentials are not yet configured. Add your PayPal Client ID & Secret in Central Admin → Settings to accept live payments.
        </div>
      )}

      {order && (
        <div className="border text-left p-7 mb-10" style={{ borderColor: "var(--ev-border)" }}>
          {order.items.map((it, i) => (
            <div key={i} className="flex gap-4 py-3 border-b last:border-0" style={{ borderColor: "var(--ev-border)" }}>
              <img src={it.image} alt="" className="w-14 h-18 object-cover" />
              <div className="flex-1">
                <div className="font-serif">{it.name}</div>
                <div className="text-xs uppercase tracking-wide" style={{ color: "var(--ev-muted)" }}>{it.storefront} · Qty {it.qty}</div>
              </div>
            </div>
          ))}
          <div className="flex justify-between font-serif text-xl pt-4">
            <span>Total ({order.currency})</span><span>{money(order.total_usd)}</span>
          </div>
        </div>
      )}
      <button onClick={() => navigate("/")} className="btn-luxe">Continue Shopping</button>
    </div>
  );
}
